// extracted by mini-css-extract-plugin
export var closeButton = "_gw-2";
export var closeButtonIcon = "_gw-3";
export var lightboxContent = "_gw-1";
export var lightboxOverlay = "_gw-0";